import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

const ProtectRoutes = () => {
  const users = useSelector((state) => state.user);
  console.log(users, "auth");
  return users?.currentUser ? (
    <div className="main">
      <Outlet />
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectRoutes;
